import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withStyles } from "@mui/styles";
import { withRouter } from "react-router-dom"; 
import classNames from "classnames";
import { bindActionCreators } from "redux";
import { myEmployeeActions } from "../../../../actions";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import {Button} from "@mui/material";
import {PersonAdd, Download, ReceiptLong} from '@mui/icons-material';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import SimpleMessageDialog from "../../../../components/SimpleMessageDialog";
import SimpleConfirmDialog from "../../../../components/SimpleConfirmDialog";
import MyEmployeeDialog from "./MyEmployeeDialog";
import TerminationEmployeeDialog from "./TerminationEmployeeDialog";
import LoadingPopup from "../../../../components/LoadingPopup";
import Util from "../../../../utils/Util";
import SnackBar from "../../../../components/SnackBar";

class MyEmployeeFooter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inviteDialog: false,
      addEmployeeDialog: false,
      terminateEmployeeDialog: false,
      showSnackBarError: false,
      selectedRecord: null,
      selectedIndex: null,
      mode: "",
      employeeDialogTitle: "",
      showDownloadDialog: false,
      downloading: false
    };
  }

  handleIconClick = name => event => {
    if (name === "add") {
      this.setState({
        addEmployeeDialog: true,
        mode: "ADD",
        employeeDialogTitle: "Add new employee",
        selectedRecord: null
      });
    } else if (name === "send") {
      this.setState({ inviteDialog: true });
    } else if (name === "delete") {
      this.setState({
        terminateEmployeeDialog: true,
        selectedRecord: this.getSelectedRecord()
      });
    }
  };

  handleCloseDialog = name => event => {
    if (name === "add") {
    } else if (name === "edit") {
    } else if (name === "send") {
      this.setState({ inviteDialog: false });
    } else if (name === "invite_success" || name === "invite_error" || name === "add_employee") {
      this.props.closePopup();
    } else if (name === "employee") {
      this.setState({ addEmployeeDialog: false });
    } else if (name === "termination") {
      this.setState({ terminateEmployeeDialog: false });
    }
  };

  handleCloseSnackbarError = () => {
    this.setState({ showSnackBarError: false });
  };

  handleSnackbarErrorEvent = event => {
    if (event.code === 400) {
      this.setState({ showSnackBarError: true });
    }
  };

  sendInvite = () => {
    this.props.showLoading(true);
    this.props.sendInvite().then(
      response => {
        this.props.showLoading(false);
      },
      error => {
        this.props.showLoading(false);
      }
    );
    this.handleCloseDialog("send")();
  };

  getSelectedRecord() {
    let selectedId = this.props.selectedIds[0];
    if (selectedId) {
      return this.props.myEmployee.data.filter(d => d.person_id === selectedId)[0];
    }
    return null;
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  onCellClickHandler = personId => {
    let selectedIndex = null;
    const selectedRecord = this.props.myEmployee.data.filter((d, id) => {
      if (d.person_id === personId) {
        selectedIndex = id;
      }
      return d.person_id === personId;
    })[0];

    this.setState({
      addEmployeeDialog: true,
      mode: "EDIT",
      employeeDialogTitle: "Edit Employee",
      selectedRecord: selectedRecord,
      selectedIndex: selectedIndex
    });
  };

  confirmTerminateEmployee = date => {
    this.props.showLoading(true);
    //call api with this termination date
    const { updateEmployee } = this.props;
    let selectedRecord = Util.clone(this.state.selectedRecord);
    selectedRecord["coverage_end_date"] = date;

    //Set dependents coverage_end_date as well
    selectedRecord.dependents.forEach(d => {
      d["coverage_end_date"] = date;
    });

    updateEmployee({
      member: selectedRecord,
      dependents: selectedRecord.dependents
    }).then(
      response => {
        this.props.showLoading(false);
      },
      error => {
        this.props.showLoading(false);
      }
    );
    this.handleCloseDialog("termination")();
  };

  handleGoToDocuments = () => {
    const { policyNumber, companyId, company, productCode } = this.props.location.state || {};
    
    this.props.history.push({
      pathname: "/auth/documents/detail/memberTransactionLog",
      state: {
        policyNumber,
        companyId,
        company,
        productCode
      }
    });
  };

  // open download dialog
  handleOpenDownloadDialog = () => {
    this.setState({ showDownloadDialog: true });
  };

  // close download dialog
  handleCloseDownloadDialog = () => {
    if (!this.state.downloading) {
      this.setState({ showDownloadDialog: false });
    }
  };

  // confirm download then start
  handleConfirmDownload = () => {
    this.setState({ showDownloadDialog: false }, this.handleDownloadMemberListing);
  };

  // perform download via action
  handleDownloadMemberListing = async () => {
    if (this.state.downloading) return;
    
    const policyNumber = this.props.policyDetails?.policy?.policy_no;
    const companyId = this.props.policyDetails?.policy?.account_id;
    
    if (!policyNumber || !companyId) return;
    this.setState({ downloading: true });
    try {
      const { blob, filename } = await this.props.downloadMemberListing(policyNumber, companyId);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "member-listing.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Download failed:", e);
    } finally {
      this.setState({ downloading: false });
    }
  };

  render() {
    const { classes, navDrawerOpen, selectedIds, policyDetails } = this.props;
    const { inviteDialog, addEmployeeDialog, selectedRecord, selectedIndex, mode, employeeDialogTitle, showDownloadDialog, downloading } = this.state;
    return (
      <div className={classNames(classes.root, navDrawerOpen && classes.menuShow)}>
        <div className={classes.buttonRow}>
        <Button size="medium" disabled={policyDetails?.policy?.renewal_submitted} onClick={this.handleIconClick("add")} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
          <PersonAdd fontSize="medium" style={{ color: "#ED1C24" }}/>Add New Employee 
        </Button>
        <Button size="medium" onClick={this.handleOpenDownloadDialog} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
          <Download fontSize="medium" style={{ color: "#ED1C24" }}/>Download Member Listing
        </Button>
        <Button size="medium" onClick={this.handleGoToDocuments} sx={{ border: "2px solid #ED1C24", borderRadius: "8px" }}>
          <ReceiptLong fontSize="medium" style={{ color: "#ED1C24" }}/>View Transaction Log 
        </Button>
        </div>

        {/*for invitation employee*/}
        <SimpleConfirmDialog
          open={inviteDialog}
          name="email-detail-dialog"
          title="Send Invite To Selected Employees?"
          description="Selected employees will receive an email to login and activate
                their insurance account."
          closeButtonText="Cancel"
          closeHandler={this.handleCloseDialog("send")}
          okButtonText="Send invite"
          okHandler={this.sendInvite}
        />

        <SimpleMessageDialog
          type="success"
          name="send-invite-success"
          title="Invites Sent!"
          description="Your employees can now activate their Employee portal via the link sent in the email invite."
          closeButtonText="OK"
          closeHandler={this.handleCloseDialog("invite_success")}
          open={this.props.myEmployee.showInviteSuccess}
        />

        <SimpleMessageDialog
          type="error"
          name="send-invite-error"
          title="There was a problem"
          description="We are unable to complete the invites as this moment, please try again later"
          closeButtonText="OK"
          closeHandler={this.handleCloseDialog("invite_error")}
          open={this.props.myEmployee.showInviteError}
        />

        {addEmployeeDialog && (
          <MyEmployeeDialog
            open={addEmployeeDialog}
            selectedRecord={selectedRecord}
            selectedIndex={selectedIndex}
            title={employeeDialogTitle}
            mode={mode}
            readOnly={mode === "VIEW"}
            handleClose={this.handleCloseDialog("employee")}
            handleEmployeeError={this.handleSnackbarErrorEvent}
            policyDetails={policyDetails}
          />
        )}

        <SimpleMessageDialog
          isHtml={true}
          type="success"
          name="employee-success"
          title="Submitted"
          description="Thank you for your submission on PRUWorks. We will be in touch with you if we have any queries. Otherwise, we will proceed to update the member data within 3 to 5 working days.<br/><br/>If any medical underwriting is required, we will be sending a separate email to HR."
          closeButtonText="OK"
          closeHandler={this.handleCloseDialog("add_employee")}
          open={this.props.myEmployee.showEmployeeSuccess}
        />

        <LoadingPopup name="my-employee-footer-loading" open={this.props.myEmployee.showLoading} />

        <Dialog
          open={showDownloadDialog}
            onClose={this.handleCloseDownloadDialog}
          classes={{ paper: classes.downloadDialogPaper }}
        >
          <DialogContent>
            <Typography variant="body2" gutterBottom>
              <strong>Note:</strong> Member listing reflects data as at{" "}
              {new Date()
                .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                .toUpperCase()}
              .
            </Typography>
            <Typography variant="body2" style={{ marginTop: 12 }}>
              If you have recently submitted a movement request, please allow up to 5 working days for
              updates to be reflected in the system.
            </Typography>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
              <Button
                variant="contained"
                color="error"
                onClick={this.handleConfirmDownload}
                disabled={downloading}
                style={{ marginLeft: 8 }}
              >
                Proceed
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {this.state.showSnackBarError && (
          <SnackBar
            type="error"
            open={this.state.showSnackBarError}
            onClose={this.handleCloseSnackbarError}
            message="An error has occurred when processing the Employee's information, please try again."
          />
        )}

        {this.state.terminateEmployeeDialog && (
          <TerminationEmployeeDialog
            open={this.state.terminateEmployeeDialog}
            selectedRecord={selectedRecord}
            name={"EmployeeSuccess"}
            icon={<Icon style={{ fontSize: 50, color: "red" }}>delete</Icon>}
            closeButtonText={"OK"}
            setTerminationDate={this.setTerminationDate}
            closeHandler={this.handleCloseDialog("termination")}
            confirmHandler={this.confirmTerminateEmployee}
          />
        )}
        {policyDetails?.policy?.renewal_submitted && (
          <p className={classes.renewNote}>
            <strong>Note:</strong> Please submit or upload member changes after policy had been renewed successfully.
            Please reach out to your financial consultant for assistance.
          </p>
        )}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    backgroundColor: "white",
    position: "fixed",
    right: 0,
    bottom: 0,
    left: theme.miniLeftDrawer.widthClosed,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px 0 0 0",
    padding: "10px 20px",
    zIndex: 1200
  },
  downloadDialogPaper: {
    width: 300,
    borderRadius: 4
  },
  buttonRow: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px"
  },
  renewNote: {
    width: "100%",
    margin: 0,
    padding: "5px",
    textAlign: "left"
  },
  menuShow: {
    left: theme.miniLeftDrawer.width
  }
});

function mapStateToProps(state) {
  return { myEmployee: state.HR.myemployee };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(myEmployeeActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withRouter(withStyles(styles, { withTheme: true })(MyEmployeeFooter))));
